import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
const SSpinner = ({ size = "md", color = "currentColor" })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "relative animate-spin",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
            type: "spinner",
            size: size,
            color: color
        })
    });
const SOverlaySpinner = ({ size = "md", overlayColor = "rgba(0,0,0,0)", color = "currentColor" })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "flex justify-center items-center absolute top-0 left-0 bg-[#121316AA] w-full h-full",
        style: {
            background: overlayColor
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SSpinner, {
            size: size,
            color: color
        })
    });
export { SOverlaySpinner, SSpinner };
